import { createContext, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import en from "./en";
import nl from "./nl";

const translations = { en, nl };

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const match = pathname.match(/^\/(en|nl)(?=\/|$)/);
  const lang = match ? match[1] : "en";
  const t = translations[lang];

  const switchLang = (next) => {
    if (next === lang) return;
    const rest = pathname.replace(/^\/(en|nl)/, "");
    navigate(`/${next}${rest || ""}${search}`, { replace: false });
    window.scrollTo(0, 0);
  };

  return (
    <LanguageContext.Provider value={{ lang, t, switchLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
